document.addEventListener('DOMContentLoaded', function() {
  if (window.location.pathname === '/products/heat') {
    var sliderHTML = `
      <div class="image-text-slider-wrapper">
      <h2 class="mt-1 mb-8 text-[32px] lg:text-[40px] font-medium leading-[120%] font-interRegular">How HEAT Works</h2>
        <div class="swiper image-text-slider" js-mobile-slider="container">
          <div class="swiper-wrapper">
            <div class="swiper-slide">
              <div class="image-text-block">
                <img src="https://cdn.shopify.com/s/files/1/0507/8358/4447/files/unroll_final_v2.gif?v=1756586453"/>
                <h3 class="font-bold lg:text-[20px] pt-8 pb-4">Lay Down & Position</h3>
                <p>Unroll it, place your elbow or heel in the sleeve and THEN… press POWER button for 3 seconds (ON/OFF).</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="image-text-block">
              <img src="https://cdn.shopify.com/s/files/1/0507/8358/4447/files/turn_on_final.gif?v=1756586453"/>
                <h3 class="font-bold lg:text-[20px] pt-8 pb-4">Warm Up</h3>
                <p>Wear thin socks for optimal comfort. The longer you use the device, the hotter it will feel, gently warming the targeted area and helping relax tight muscles.</p>
              </div>
            </div>
            <div class="swiper-slide">
              <div class="image-text-block">
              <img src="https://cdn.shopify.com/s/files/1/0507/8358/4447/files/stretch_final.gif?v=1756586452"/>
                <h3 class="font-bold lg:text-[20px] pt-8 pb-4">Stretch & Enhance Recovery</h3>
                <p>The CastleFlexx Heat Edition helps increase circulation, improves your overall stretching experience and increases flexibility faster.</p>
              </div>
            </div>
          </div>
          <div class="swiper-pagination" js-mobile-slider="pagination"></div>
        </div>
      </div>
    `;

    // insert before .image-hotspots
    var target = document.querySelector(".image-hotspots");
    if (target) {
      target.insertAdjacentHTML("beforebegin", sliderHTML);
    }

    if (window.innerWidth < 768){
    const container = document.querySelector('[js-mobile-slider="container"]');
    const pagination = document.querySelector('[js-mobile-slider="pagination"]');
    // Init Swiper using theme’s alias (O + ne)
      new O(container, {
        modules: [ne],
        slidesPerView: 1.6,
        spaceBetween: 15,
        loop: true,
        pagination: {
          el: pagination,
          clickable: true,
        },
      });
    }
  }
  // Enavi 3-1-R-HP-Featured Products ATC //
  const urlParams = new URLSearchParams(window.location.search);
  if (urlParams.get('trigger_atc') === 'true') {
    document.body.classList.add("show-atc-popup");
  const escapeSelector = s => CSS?.escape ? CSS.escape(s) : s;
  // Show/hide variant popup
  const handlePopupToggle = (btn) => {
    const targetClass = btn.getAttribute("data-target");
    if (!targetClass) return;

    document.querySelectorAll(".plp-variant-inner").forEach(el => el.classList.remove("active-plp-variant"));

    const targetEl = document.querySelector(`.plp-variant-inner.${targetClass}`);
    if (targetEl) {
      targetEl.classList.add("active-plp-variant");
      document.body.classList.add("variant-popup-open");
    }
  };

  const closeAllPopups = () => {
    document.querySelectorAll(".plp-variant-inner").forEach(el => el.classList.remove("active-plp-variant"));
    document.body.classList.remove("variant-popup-open");
  };

  // Update the label <span> text
  const updateLabel = (swatch) => {
    const optionGroup = swatch.closest("fieldset");
    if (!optionGroup) return;

    const labelSpan = optionGroup.closest(".plp-options-wrapper")?.querySelector(".option-name span");
    if (labelSpan) labelSpan.textContent = swatch.getAttribute("data-swatch") || swatch.getAttribute("data-value") || swatch.getAttribute("data-color");
  };
  const getSelectedVariant = (activePopup) => {
    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return null;

    const selectedValues = Array.from(activePopup.querySelectorAll("fieldset input:checked"))
      .map(inp => inp.value);

    return Array.from(hiddenSelect.options).find(opt => {
      const optValues = [opt.getAttribute("data-option1"), opt.getAttribute("data-option2"), opt.getAttribute("data-option3")].filter(Boolean);
      return selectedValues.every(val => optValues.includes(val)) && !opt.disabled;
    });
  };

  const updatePrice = (activePopup) => {
    const matchedVariant = getSelectedVariant(activePopup);
    const priceEl = activePopup.querySelector(".plp-variant-price");
    if (priceEl) {
      priceEl.textContent = matchedVariant?.getAttribute("data-price") || '';
    }
    if(matchedVariant?.getAttribute("data-price") == undefined){
      activePopup.querySelector(".add-product-plp").style.display = "none";
    }
    else{
      activePopup.querySelector(".add-product-plp").style.display = "inline-block";
    }
  };
  // Handle availability logic for dependent option
  const handleAvailability = (activePopup, firstSwatch) => {
    const fieldsets = activePopup.querySelectorAll(".plp-options-wrapper fieldset");
    if (fieldsets.length < 2) return;

    const firstOptionName = fieldsets[0].id;
    const secondOptionName = fieldsets[1].id;

    if (firstSwatch.closest("fieldset").id !== firstOptionName) return;

    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return;

    const targetSelector = `#${escapeSelector(secondOptionName)} .swatch, #${escapeSelector(secondOptionName)} .button-swatch`;
    const targetSwatches = activePopup.querySelectorAll(targetSelector);

    let firstAvailable = null;
    const firstValue = firstSwatch.getAttribute("data-value") || firstSwatch.getAttribute("data-color");

    targetSwatches.forEach(ts => {
      const targetValue = ts.getAttribute("data-value") || ts.getAttribute("data-color");

      const match = Array.from(hiddenSelect.options).find(opt => {
        return (opt.getAttribute("data-option1") === firstValue && opt.getAttribute("data-option2") === targetValue);
      });

      const isAvailable = !!match;
      const isSoldout = match?.disabled || false;

      ts.classList.toggle("unavailable", !isAvailable);
      ts.classList.toggle("sold-out", !!isSoldout);

      if (isAvailable && !isSoldout && !firstAvailable) firstAvailable = ts;
    });

    const selectedTarget = activePopup.querySelector(`#${escapeSelector(secondOptionName)} .selected`);
    if (!selectedTarget || selectedTarget.classList.contains("unavailable") || selectedTarget.classList.contains("sold-out")) {
      if (firstAvailable) firstAvailable.click();
    }
    // Update price after availability changes
    setTimeout(() => {
      updatePrice(activePopup);
    }, 100);
  };

  // Handle visual selection
  const markSelected = (swatch) => {
    const optionGroup = swatch.closest("fieldset");
    if (!optionGroup) return;
    optionGroup.querySelectorAll("label").forEach(l => l.classList.remove("selected"));
    swatch.classList.add("selected");
  };

  // Get variant ID based on selected options
  const getSelectedVariantId = (activePopup) => {
    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return null;

    const selectedValues = Array.from(activePopup.querySelectorAll("fieldset input:checked"))
      .map(inp => inp.value);

    const matchedVariant = Array.from(hiddenSelect.options).find(opt => {
      const optValues = [
        opt.getAttribute("data-option1"),
        opt.getAttribute("data-option2"),
        opt.getAttribute("data-option3")
      ].filter(Boolean);

      return selectedValues.every(val => optValues.includes(val)) && !opt.disabled;
    });

    return matchedVariant?.value || null;
  };
  const getSelectedVariantSellingPlanId = (activePopup) => {
    const hiddenSelect = activePopup.querySelector(".plp-hidden-variant-data");
    if (!hiddenSelect) return null;

    const selectedValues = Array.from(activePopup.querySelectorAll("fieldset input:checked"))
      .map(inp => inp.value);

    const matchedVariant = Array.from(hiddenSelect.options).find(opt => {
      const optValues = [
        opt.getAttribute("data-option1"),
        opt.getAttribute("data-option2"),
        opt.getAttribute("data-option3")
      ].filter(Boolean);

      return selectedValues.every(val => optValues.includes(val)) && !opt.disabled;
    });

    return matchedVariant?.getAttribute('data-selling') || null;
  };
  // Add variant to cart
  const addToCart = (variantId,sellingId) => {
    if (!variantId) return;
    const payload = {
      id: variantId,
      quantity: 1
    };
    if (sellingId && sellingId != "" && sellingId != null) {
      payload.selling_plan = sellingId;
    }
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload)
    })
    .then(res => res.json())
    .then(() => document.querySelector('#cart-icon-bubble')?.click())
    .catch(err => console.error(err));
  };

  // Event delegation
  document.addEventListener("click", (e) => {
    const popupBtn = e.target.closest(".trigger-variant-popup");
    if (popupBtn) return handlePopupToggle(popupBtn);

    const swatch = e.target.closest(".button-swatch, .swatch");
    if (swatch) {
      const activePopup = document.querySelector(".plp-variant-inner.active-plp-variant");
      if (!activePopup) return;

      updateLabel(swatch);
      handleAvailability(activePopup, swatch);
      markSelected(swatch);
      return;
    }

    const addBtn = e.target.closest(".add-product-plp");
    if (addBtn) {
      const activePopup = addBtn.closest(".plp-variant-inner");
      if (!activePopup) return;
      const variantId = getSelectedVariantId(activePopup);
      const sellingId = getSelectedVariantSellingPlanId(activePopup);
      addToCart(variantId,sellingId);
      return;
    }

    if (!e.target.closest(".plp-variant-options") && !e.target.closest(".trigger-variant-popup")) {
      closeAllPopups();
    }
  });
  setTimeout(function(){
    renderSwatchDescriptions();
  },3000)
  
    function renderSwatchDescriptions() {
      document.querySelectorAll(".plp-swatch").forEach(swatch => {
        const sizeKey = swatch.getAttribute("data-value")?.toLowerCase();
        const sizeTextEl = swatch.querySelector(".size-text");
        if (sizeKey && window.sizeOptions && window.sizeOptions[sizeKey] && sizeTextEl) {
          sizeTextEl.textContent = window.sizeOptions[sizeKey].replace(/\/quote\//g, '"').replace(/\/apos\//g, "'");
        }
      });
    }
  }
// Enavi 3-1-R-HP-Featured Products ATC //

// Hide Review Stars if a product has less than 20 reviews.  //
(function () {
  document.querySelectorAll('.product__info-container [data-raters]').forEach(el => {
    const raters = parseInt(el.getAttribute('data-raters'), 10);
    if (isNaN(raters) || raters < 20) {
      const parent = el.parentElement;
      if (parent) parent.style.display = "none";
      if (!parent.nextElementSibling || !parent.nextElementSibling.classList.contains("product-grid-item__label")) {
        const span = document.createElement("span");
        span.className = "product-grid-item__label bg-[#B9CBDD] rounded-full text-sm font-medium text-[#191A1B] py-1 px-3 z-10";
        span.textContent = "NEW!";

        parent.insertAdjacentElement("afterend", span);
      }

    }
  });
})();
// Hide Review Stars if a product has less than 20 reviews.  //

// Implementation - 14-1-R-PDP-Chronic Pain Accordions //
(function () {
  const section = document.querySelector('.castleflexx-section');
  if (!section) return;
  const headers = section.querySelectorAll('.accordion-header');
  headers.forEach(header => {
    header.addEventListener('click', () => {
      const item = header.closest('.accordion-item');
      const content = item.querySelector('.accordion-content');
      const toggle = header.querySelector('.accordion-toggle');
      const isOpen = !content.classList.contains('hidden');
      section.querySelectorAll('.accordion-content').forEach(el => el.classList.add('hidden'));
      section.querySelectorAll('.accordion-toggle').forEach(el => el.textContent = '+');
      if (!isOpen) {
        content.classList.remove('hidden');
        toggle.textContent = '−';
      }
    });
  });
})();
// Implementation - 14-1-R-PDP-Chronic Pain Accordions //

// Implementation - 17-1-R-FIT-Product Image Carousel //
(function () {
  const mainContainer = document.querySelector('#main-swiper');
  const thumbContainer = document.querySelector('[js-thumb-slider="container"]');
  if (!mainContainer || !thumbContainer) return;
  const thumbSlider = new O(thumbContainer, {
    modules: [ne],
    slidesPerView: window.innerWidth >= 768 ? 7.5 : 5.5,
    loop: false,
    spaceBetween: 5,
    watchOverflow: true,
    watchSlidesProgress: true,
  });

  // Main slider
  const mainSlider = new O(mainContainer, {
    modules: [ne],
    slidesPerView: 1,
    loop: false,
    spaceBetween: 15,
  });

  // ---------- MANUAL SYNC ----------

  thumbSlider.slides.forEach((slide, index) => {
    slide.addEventListener("click", () => {
      mainSlider.slideTo(index);
    });
  });

  mainSlider.on("slideChange", () => {
    const index = mainSlider.activeIndex;

    thumbSlider.slides.forEach((slide, i) => {
      slide.classList.toggle("thumb-active", i === index);
    });

    thumbSlider.slideTo(index);
  });
})();
// Implementation - 17-1-R-FIT-Product Image Carousel //

/* Vimeo Course Videos */
(function () {
  const players = new Map();

  function formatTime(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return mins + ':' + (secs < 10 ? '0' : '') + secs;
  }

  function initPlayer(iframe) {
    if (players.has(iframe)) return;
    const container = iframe.closest('.vimeo-wrapper');
    if (!container) return;

    const player = new Vimeo.Player(iframe);
    players.set(iframe, player);

    const playBtn = container.querySelector('.vimeo-play-btn');
    const poster = container.querySelector('.vimeo-poster');
    const durationEl = container.querySelector('.castlefit--media_length');

    playBtn?.addEventListener('click', () => {
      players.forEach((p, el) => {
        if (el !== iframe) p.pause();
      });
      player.play();
    });

    player.on('play', () => {
      players.forEach((p, el) => {
        if (el !== iframe) p.pause();
      });
      playBtn?.classList.add('hidden');
      poster?.classList.add('hidden');
    });

    player.on('pause', () => {
      playBtn?.classList.remove('hidden');
      poster?.classList.remove('hidden');
    });

    player.on('ended', () => {
      playBtn?.classList.remove('hidden');
      poster?.classList.remove('hidden');
    });

    player.on('loaded', () => {
      player.getDuration().then((duration) => {
        if (durationEl && !durationEl.dataset.loaded) {
          durationEl.textContent = formatTime(duration);
          durationEl.dataset.loaded = 'true';
        }
      });
    });
  }

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        const wrapper = entry.target;
        const iframe = wrapper.querySelector('iframe[data-src]');
        if (!iframe) return;

        iframe.addEventListener('load', () => initPlayer(iframe), { once: true });
        iframe.src = iframe.dataset.src;
        iframe.removeAttribute('data-src');

        observer.unobserve(wrapper);
      });
    },
    { rootMargin: '200px 0px', threshold: 0.01 }
  );

  document.querySelectorAll('.vimeo-wrapper').forEach((el) => {
    observer.observe(el);
  });

})();
/* Vimeo Course Videos */
})

// FAV Accessibility: Add aria-labels to color swatches on product pages //
document.querySelectorAll('#Color label.swatch').forEach(label => {
  const color = label.getAttribute('data-color');

  if (color) {
    const readable = color.replace('-', ' ');
    label.setAttribute('aria-label', `Color: ${readable}`);
  }
});
// FAV Accessibility: Remove aria-label from video tag //
document.querySelectorAll('video').forEach(video => {
  video.removeAttribute('aria-label');
});

/* Implementation - CastleFlexx Luxury Black Large shipping message */
(function () {
  if (!window.location.pathname.endsWith('/products/castle-flexx')) return;

  const BLACK_LARGE_VARIANT_ID = '43357056172223';

  function getVariantPicker() {
    return document.querySelector('.product__info-container #product-options');
  }

  function getMessage() {
    return document.getElementById('variant-shipping-message');
  }

  function getActiveVariantId(picker) {
    if (!picker) return null;

    const dataVariant = picker.getAttribute('data-variant');
    if (dataVariant) return String(dataVariant);

    const buyButton = document.querySelector('.product__info-container buy-button');
    if (buyButton?.id) return String(buyButton.id);

    return null;
  }

  function shouldShowMessage(picker) {
    if (!picker) return false;

    if (getActiveVariantId(picker) === BLACK_LARGE_VARIANT_ID) return true;

    const size = picker.querySelector('input[name="select-option1"]:checked')?.value;
    const color = picker.querySelector('input[name="select-option2"]:checked')?.value;
    return size === 'Large' && color === 'Black';
  }

  function setMessageVisibility(show) {
    const message = getMessage();
    if (!message) return;

    message.toggleAttribute('hidden', !show);
    message.classList.toggle('is-hidden', !show);
    message.setAttribute('aria-hidden', show ? 'false' : 'true');
  }

  function repositionMessage() {
    const message = getMessage();
    const colorFieldset = getVariantPicker()?.querySelector('#Color');
    if (!message || !colorFieldset || message.previousElementSibling === colorFieldset) return;
    colorFieldset.insertAdjacentElement('afterend', message);
  }

  function updateVariantShippingMessage() {
    const message = getMessage();
    if (!message) return;

    const picker = getVariantPicker();
    repositionMessage();
    setMessageVisibility(shouldShowMessage(picker));
  }

  function bindPickerObservers(picker) {
    if (!picker || picker.dataset.shippingMessageBound === 'true') return;
    picker.dataset.shippingMessageBound = 'true';

    picker.addEventListener('change', () => {
      setTimeout(updateVariantShippingMessage, 0);
    });

    new MutationObserver(updateVariantShippingMessage).observe(picker, {
      attributes: true,
      attributeFilter: ['data-variant'],
      childList: true,
      subtree: true,
    });

    const buyButton = document.querySelector('.product__info-container buy-button');
    if (buyButton) {
      new MutationObserver(updateVariantShippingMessage).observe(buyButton, {
        attributes: true,
        attributeFilter: ['id'],
      });
    }
  }

  function initVariantShippingMessage() {
    const message = getMessage();
    if (!message) return false;

    bindPickerObservers(getVariantPicker());
    updateVariantShippingMessage();
    return true;
  }

  document.querySelector('.product__info-container')?.addEventListener('click', (event) => {
    if (!event.target.closest('#Size, #Color')) return;
    setTimeout(updateVariantShippingMessage, 50);
  });

  if (!initVariantShippingMessage()) {
    const initInterval = setInterval(() => {
      initVariantShippingMessage();
      if (getVariantPicker()?.querySelector('#Color')) clearInterval(initInterval);
    }, 100);

    setTimeout(() => clearInterval(initInterval), 15000);
  }
})();
/* Implementation - CastleFlexx Luxury Black Large shipping message */

/* Implementation - 23-1-R-PDP-Color Selector */
(function () {
  // Restrict on PDP only - homepage featured products also render #Color and hang the page
  if (!/\/products\//.test(window.location.pathname)) return;

  const isCastleFlexxPath = /\/products\/castle-flexx\/?$/.test(window.location.pathname);

  let colorObserver = null;

  const fallbackColorImages = {
    'black/gold': 'https://castleflexx.com/cdn/shop/files/IMG_9559.jpg?v=1732461501',
    black: 'https://castleflexx.com/cdn/shop/files/CastleFlexx_Blck_Float.jpg?v=1762198506',
    navy: 'https://castleflexx.com/cdn/shop/files/CastleFlexx_Darkblue_Float.jpg?v=1762198395',
    green: 'https://castleflexx.com/cdn/shop/files/SuperGreen.jpg?v=1759300076',
    mint: 'https://castleflexx.com/cdn/shop/files/CastleFlexx_Mint_Float_f89545e8-3ef4-43a5-b331-451f97a175dd.jpg?v=1732661364',
    fire: 'https://castleflexx.com/cdn/shop/files/CastleFlexx_Rainbow_Float.jpg?v=1719305589',
    aqua: 'https://castleflexx.com/cdn/shop/files/CastleFlexx_Aqua_Float.jpg?v=1719305366',
    purple: 'https://castleflexx.com/cdn/shop/files/CastleFlexx_Purple_Float_e52da337-a9cc-4eac-9b2b-74f635dae5bf.jpg?v=1759301544',
    'light grey': 'https://cdn.shopify.com/s/files/1/0507/8358/4447/files/CastleFlexx_Grey_Float_200x.webp?v=1771516487',
    pink: 'https://castleflexx.com/cdn/shop/files/IMG_4950.jpg?v=1762198508'
  };

  function buildColorCards() {
    const variantWrapper = document.querySelector('#product-options');
    const colorFieldset = document.querySelector('#Color');

    if (!colorFieldset) return;

    const isCastleFlexxProduct =
      isCastleFlexxPath || variantWrapper?.getAttribute('data-handle') === 'castle-flexx';
    const hasCastleFlexxColors = Array.from(
      colorFieldset.querySelectorAll('input.product__variant--button')
    ).some(input => fallbackColorImages[input.value.trim().toLowerCase()]);

    if (!isCastleFlexxProduct && !hasCastleFlexxColors) return;

    let raw = variantWrapper?.getAttribute('js-variants');
    let variants = [];

    if (raw) {
      // Fix Shopify invalid JSON
      raw = raw
        .replace(/'/g, '"')
        .replace(/,\s*]/g, ']')
        .replace(/,\s*}/g, '}');

      try {
        variants = JSON.parse(raw);
      } catch (e) {
        console.error('Variant JSON parse failed', e);
      }
    }

    // Build color → image map (prefer available)
    const colorImageMap = {};
    variants.forEach(v => {
      if (!v.option2 || !v.featured_image) return;

      const key = v.option2.trim().toLowerCase();

      if (!colorImageMap[key] || v.available) {
        colorImageMap[key] = v.featured_image.startsWith('//')
          ? 'https:' + v.featured_image
          : v.featured_image;
      }
    });

    // detach so our processing below don't retrigger the observer
    if (colorObserver) colorObserver.disconnect();

    // Transform each swatch
    colorFieldset.querySelectorAll('label.swatch').forEach(label => {
      // skip if already drawn; redraw if the theme wiped the image
      if (label.querySelector('.swatch-card-image')) return;

      const forId = label.getAttribute('for');
      const input = document.getElementById(forId);
      if (!input) return;

      const colorName = input.value.trim();
      const key = colorName.toLowerCase();
      const img = colorImageMap[key] || fallbackColorImages[key];
      const isSoldOut = input.disabled || label.classList.contains('sold-out');

      // Clear existing content (but keep label element)
      label.innerHTML = '';

      if (img) {
        const imgBox = document.createElement('div');
        imgBox.className = 'swatch-card-image';
        imgBox.style.backgroundImage = `url("${img}")`;
        label.appendChild(imgBox);
      }

      if (isSoldOut) {
        const soldOutOverlay = document.createElement('div');
        soldOutOverlay.className = 'absolute inset-0 flex items-center';
        soldOutOverlay.innerHTML = '<div class="w-full border-t-2 border-black transform rotate-45 h-[2px] bg-[#E6E6E6]" style="transform: rotate(135deg);"></div>';
        label.appendChild(soldOutOverlay);
      }

      const text = document.createElement('div');
      text.className = 'swatch-card-label';
      text.textContent = colorName;
      label.appendChild(text);
    });

    // reattach after done editing
    if (colorObserver) colorObserver.observe(colorFieldset, { childList: true, subtree: true });
  }

  // Initial run
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', buildColorCards);
  } else {
    buildColorCards();
  }

  // Watch for Color block being re-rendered by theme (on size change)
  let observerStarted = false;

  const watchInterval = setInterval(() => {
    const colorFieldset = document.querySelector('#Color');
    if (!colorFieldset || observerStarted) return;

    observerStarted = true;
    clearInterval(watchInterval);

    colorObserver = new MutationObserver(() => {
      buildColorCards();
    });

    colorObserver.observe(colorFieldset, { childList: true, subtree: true });
  }, 300);
})();

/* Implementation - 23-1-R-PDP-Color Selector */

/* Implementation - 24-1-R-PDP-Thumbnails */
(function () {
  if (window.innerWidth > 767) return;

  function sanitizeColor(c) {
    return c.replace(/\s+/g, '-').replace(/&/g, '-').toLowerCase();
  }

  const desktopGallery = document.querySelector(".desktop-product-gallery");
  if (desktopGallery) desktopGallery.style.display = "none";

  const mobileGallery = document.querySelector(".swiper-product-gallery");
  if (!mobileGallery) return;
  mobileGallery.classList.remove("lg:hidden");

  function waitForSwiper(cb, attempts = 0) {
    if (window.productGallery) return cb(window.productGallery);
    if (attempts > 50) return console.warn("[Thumbs] productGallery never appeared after 5s");
    setTimeout(() => waitForSwiper(cb, attempts + 1), 100);
  }

  let isVariation = false;
  let filterByColorFn = null;

  window.onIgReady = function () {
    const testGroup = window.igData?.user?.getTestGroup("b1df9747-bf25-4eaf-8012-f93882678eda");
    isVariation = testGroup && testGroup.isControl === false;
    if (filterByColorFn) filterByColorFn(getSelectedColor());
  };

  function getSelectedColor() {
    const checked = document.querySelector("#Color input.product__variant--button:checked");
    return checked ? sanitizeColor(checked.value) : null;
  }

  waitForSwiper(initThumbs);

  function initThumbs(mainSwiper) {
    const wrapper = mobileGallery.querySelector(".swiper-wrapper");
    const allSlides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
    if (!allSlides.length) return;

    const slideIndexMap = new Map(allSlides.map((el, i) => [el, i]));

    const stash = document.createElement("div");
    stash.style.display = "none";
    mobileGallery.appendChild(stash);

    const slideData = allSlides.map(slide => {
      const isVideo = slide.tagName === "VIDEO";
      const isExtra = slide.classList.contains("extra-images");
      return {
        el: slide,
        color: (isVideo || isExtra) ? "__special__" : sanitizeColor(slide.getAttribute("alt") || ""),
        isVideo,
        isExtra
      };
    });

    const colorFirstIndex = new Map();
    slideData.forEach(({ color, isVideo, isExtra }, i) => {
      if (!isVideo && !isExtra && color && !colorFirstIndex.has(color)) {
        colorFirstIndex.set(color, i);
      }
    });

    const thumbContainer = document.createElement("div");
    thumbContainer.className = "custom-thumbs";
    mobileGallery.appendChild(thumbContainer);

    const allThumbs = slideData.map(({ el, isVideo, isExtra }, i) => {
      const img = isVideo || isExtra
        ? (el.getAttribute("thumb") || el.src || "")
        : (el.src || el.getAttribute("thumb") || "");

      const thumb = document.createElement("button");
      thumb.className = "thumb-item";
      thumb.dataset.index = i;
      thumb.innerHTML = img
        ? `<img src="${img}" loading="lazy">`
        : `<span class="thumb-video-icon">▶</span>`;
      thumbContainer.appendChild(thumb);
      return thumb;
    });

    function setActive(realIndex) {
      allThumbs.forEach(el => el.classList.remove("active"));
      const active = allThumbs[realIndex];
      if (!active) return;
      active.classList.add("active");

      const cRect = thumbContainer.getBoundingClientRect();
      const tRect = active.getBoundingClientRect();
      thumbContainer.scrollTo({
        left: thumbContainer.scrollLeft + tRect.left - cRect.left - cRect.width / 2 + tRect.width / 2,
        behavior: "smooth"
      });
    }

    function getRealIndex() {
      const activeEl = mainSwiper.slides[mainSwiper.activeIndex];
      return activeEl ? (slideIndexMap.get(activeEl) ?? -1) : -1;
    }

    mainSwiper.on("slideChange", () => setActive(getRealIndex()));

    function filterByColor(color) {
      if (!color) return;

      allSlides.forEach(el => wrapper.appendChild(el));

      let colorSlideCount = 0;
      let colorThumbCount = 0;
      let orderIndex = 0;

      slideData.forEach(({ el, color: sc, isVideo, isExtra }, i) => {
        const thumb = allThumbs[i];

        if (isVideo) {
          thumb.style.display = "";
          thumb.style.order = "9999";
          return;
        }

        if (isExtra) {
          if (isVariation) {
            thumb.style.display = "";
            thumb.style.order = "9999";
          } else {
            stash.appendChild(el);
            thumb.style.display = "none";
            thumb.style.order = "";
          }
          return;
        }

        if (sc !== color) {
          stash.appendChild(el);
          thumb.style.display = "none";
          thumb.style.order = "";
          return;
        }

        colorSlideCount++;
        colorThumbCount++;

        if (isVariation && colorSlideCount > 2) stash.appendChild(el);

        thumb.style.display = isVariation && colorThumbCount > 2 ? "none" : "";
        thumb.style.order = String(orderIndex++);
      });

      mainSwiper.params.slidesPerView = 1;
      mainSwiper.update();

      const firstMatchEl = allSlides[colorFirstIndex.get(color)];
      if (firstMatchEl) {
        const liveSlides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
        const newIndex = liveSlides.indexOf(firstMatchEl);
        if (newIndex !== -1) {
          mainSwiper.slideTo(newIndex, 0);
          setActive(slideIndexMap.get(firstMatchEl) ?? -1);
        }
      }
    }

    filterByColorFn = filterByColor;

    thumbContainer.addEventListener("click", e => {
      const thumb = e.target.closest(".thumb-item");
      if (!thumb) return;
      const realIndex = parseInt(thumb.dataset.index, 10);
      const slideEl = allSlides[realIndex];
      const liveSlides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
      const wrapperIndex = liveSlides.indexOf(slideEl);
      if (wrapperIndex !== -1) {
        mainSwiper.slideTo(wrapperIndex, 0);
        setActive(realIndex);
      }
    });

    document.addEventListener("change", e => {
      if (e.target.matches("#Color input.product__variant--button") && e.target.type === "radio") {
        filterByColor(sanitizeColor(e.target.value));
      }
    });

    document.addEventListener("changeSlider", e => {
      if (!e.detail?.media_id) return;
      const mediaId = String(e.detail.media_id);
      for (const slide of allSlides) {
        if (slide.dataset.mediaId === mediaId || slide.getAttribute("data-media-id") === mediaId) {
          const liveSlides = Array.from(wrapper.querySelectorAll(".swiper-slide"));
          const wrapperIndex = liveSlides.indexOf(slide);
          if (wrapperIndex !== -1) {
            mainSwiper.slideTo(wrapperIndex, 0);
            setActive(slideIndexMap.get(slide) ?? -1);
          }
          break;
        }
      }
    });

    filterByColor(getSelectedColor());
    setActive(getRealIndex());
  }

})();

(function () {
  if (window.innerWidth > 767) return;

  const breadcrumb = document.querySelector(".castlefit-breadcrumb");
  const productTemplate = document.querySelector("product-template");
  if (!breadcrumb || !productTemplate) return;
  if (productTemplate.firstElementChild === breadcrumb) return;

  productTemplate.prepend(breadcrumb);
})();

(function () {
  if (window.innerWidth > 767) return;
  const container = document.querySelector('.product__info-container');
  if (!container) return;

  const reviewsLink = container.querySelector('[href="#looxReviews"]');
  const productTitle = container.querySelector('.product-title');
  if (!reviewsLink || !productTitle) return;
  if (productTitle.nextElementSibling === reviewsLink) return;

  productTitle.insertAdjacentElement('afterend', reviewsLink);
})();
/* Implementation - 24-1-R-PDP-Thumbnails */
(function () {
  // Touch devices synthesize a mouseover on tap but never a real mouseout,
  // so the tooltip can get stuck visible at a stale (pre-scroll) position.
  if (window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches) return;

  const tip = document.createElement('div');
  tip.className = 'sold-out-tooltip';
  document.body.appendChild(tip);

  function show(el) {
    const r = el.getBoundingClientRect();
    tip.textContent = el.classList.contains('sold-out-selectable') ? 'Notify When Available' : 'Sold out';
    tip.style.left = r.left + r.width / 2 + 'px';
    tip.style.top = r.top + 'px';
    tip.classList.add('visible');
  }
  function hide() {
    tip.classList.remove('visible');
  }

  // Event delegation so it works for dynamically added swatches too
  document.addEventListener('mouseover', (e) => {
    const swatch = e.target.closest('.swatch.sold-out, .swatch.sold-out-selectable');
    if (swatch) show(swatch);
  });
  document.addEventListener('mouseout', (e) => {
    if (e.target.closest('.swatch.sold-out, .swatch.sold-out-selectable')) hide();
  });
})();

(function initPdpSoldOutLabel() {
  function getSoldOutLabel() {
    const buyButton = document.querySelector('.product__info-container buy-button');
    return buyButton?.dataset.soldOutLabel || window.MarketFilter?.soldOutLabel || 'Sold out';
  }

  function applySoldOutLabel(cta) {
    if (!cta || !cta.disabled) return;

    const label = getSoldOutLabel();
    const text = cta.textContent.trim();

    // already converted rewriting innerHTML here retriggers the observer below
    if (cta.firstElementChild && cta.firstElementChild.matches('span.text-base') && text === label) return;

    if (text === 'Sold Out' || text === 'Sold out' || text === label) {
      cta.innerHTML = `<span class="text-base font-medium">${label}</span>`;
    }
  }

  function syncPdpBuyButton() {
    const container = document.querySelector('.product__info-container');
    if (!container) return;

    const buyButton = container.querySelector('buy-button');
    const cta = container.querySelector('.product__cta');
    if (!buyButton || !cta) return;

    if (buyButton.dataset.available === 'false') {
      cta.disabled = true;
      applySoldOutLabel(cta);
    }

    if (!cta.dataset.soldOutObserver) {
      cta.dataset.soldOutObserver = 'true';
      new MutationObserver(() => applySoldOutLabel(cta)).observe(cta, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }
  }

  document.addEventListener('DOMContentLoaded', syncPdpBuyButton);
  document.addEventListener('shopify:section:load', syncPdpBuyButton);
})();
